import { AxiosError } from 'axios';
import { ActionTree } from 'vuex';

import { ResourceService } from '../../../services/resources.service';
import { IRootState } from '../../../shared/store/shared.types';
import { IVideoParams, IVideoState } from './video.types';

const videoActions: ActionTree<IVideoState, IRootState> = {
  getVideoData({ commit }): void {
    commit('setLoading', true);

    ResourceService.loadVideoData()
      .then((videoData: unknown) => {
        commit('setLoading', false);
        commit('setVideoData', videoData);
        commit('setVideoSource', videoData);
      })
      .catch((error: AxiosError) => {
        commit('setLoading', false);
        commit('setError', error);
      });
  },

  setVideoParams({ commit }, params: IVideoParams): void {
    commit('setVideoParams', params);
  },

  increaseVideoPlaysCount({ commit, state }): void {
    commit('setVideoPlaysCount', state.videoPlaysCount + 1);
  },

  unlockQuiz({ commit }): void {
    commit('setQuizAvailable', true);
  },

  lockQuiz({ commit }): void {
    commit('setQuizAvailable', false);
  },

  unlockSeeking({ commit }): void {
    commit('setAllowFastForward', true);
    commit('setAllowFastBackward', true);
  },

  lockSeeking({ commit }): void {
    commit('setAllowFastForward', false);
    commit('setAllowFastBackward', false);
  },

};

export default videoActions;
